import React from "react";
import NumberFormat from "react-number-format";

const NumberFormatCustom = ({ inputRef, onChange, ...other }) => {
  return (
    <NumberFormat
      {...other}
      thousandSeparator
      decimalScale={2}
      fixedDecimalScale={true}
      getInputRef={inputRef}
      displayType="input"
      onValueChange={values => {
        onChange({
          target: {
            value: values.value
          }
        });
      }}
    />
  );
};

export default NumberFormatCustom;
